import React from "react";
import styles from "./styles/sidebar-modal.module.scss";
import HelpSidebarSection from "@/components/sidebar/sidebar-components/help-sidebar-section";
import SignInButton from "@/components/header/components/sign-in-button";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useProfileContext } from "@/providers/profile-provider/profile-provider";
import AiToolsSidebarSection from "@/components/sidebar/sidebar-components/ai-tools-sidebar-section";
import GuideSidebarSection from "@/components/sidebar/sidebar-components/guide-sidebar-section";
import HistorySidebarSection from "@/components/sidebar/sidebar-components/history-sidebar-section";
import Image from "next/image";
import logo from "@/assets/sidebar/logo.svg";
import Link from "next/link";
import closeIcon from "@/assets/sidebar/close-menu.svg";
import SubscribeButton from "@/components/common/sidebar-buttons/subscribe-button";
import SidebarSectionItem from "@/components/sidebar/sidebar-components/sidebar-section-item";
import InviteFriendsTertiaryButton from "@/components/common/invite/invite-friends-tertiary-button";
import LinksSidebarSection from "@/components/sidebar/sidebar-components/links-sidebar-section";
import SocialMediaSidebarSection from "@/components/sidebar/sidebar-components/social-media-sidebar-section";

const SidebarModal = () => {
  const { hideModal, showModal } = useGlobalModalContext();
  const { user, license } = useProfileContext();

  return (
    <div className={styles.wrapper}>
      <div className={styles.sidebar}>
        <div
          className={`${styles.content_wrapper} ${user?.id && styles.full_height}`}
        >
          <div className={styles.header_wrapper}>
            <Link href={"/"} onClick={hideModal}>
              <Image src={logo} alt="app" />
            </Link>
            <Image src={closeIcon} alt="menu" onClick={hideModal} />
          </div>
          <div className={styles.sections_container}>
            {license !== "Studio" && (
              <div className={styles.section_wrapper}>
                <SubscribeButton />
              </div>
            )}
          </div>
          <div className={styles.scrollable_content}>
            <AiToolsSidebarSection isOpen={true} />
            {/* <ManageSidebarSection /> */}
            <HistorySidebarSection />
            <HelpSidebarSection isOpen={false} />
            {/*<GuideSidebarSection isOpen={false} />*/}
            <div className={styles.section_wrapper}>
              <InviteFriendsTertiaryButton />
            </div>
            <LinksSidebarSection
              style={styles.section_wrapper_without_header}
            />
            <SocialMediaSidebarSection />
          </div>
        </div>

        {!user && <SignInButton />}
      </div>
    </div>
  );
};

export default SidebarModal;
